"use client";

import React from "react";
import mug from "../../assets/mug.png";

export default function BusinessHero() {
  return (
    <section id="hero-shop" className="relative w-full">
      <div
        className="w-full h-[260px] sm:h-[320px] lg:h-[360px] bg-cover bg-center"
        style={{
          backgroundImage: `url(${mug.src})`,
          backgroundPosition: "center right",
        }}
      >
        <div className="w-full h-full flex items-center justify-center">
          <div className="text-center px-4">
            <h1 className="inline-block px-6 sm:px-10 py-2 sm:py-3 text-white text-3xl sm:text-5xl font-extrabold tracking-tight">
              UIII Business
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
}